import { Entity } from "@thewebops/admin-panel";
import actions from "./actions";
import reducers from "./reducers";
import sagas from "./sagas";
import moment from "moment";

export default new Entity({
  name: "categoryGroup",
  pluralName: "categoryGroups",
  pathName: "category_groups",
  endpoint: "/admin/category_groups",
  serverName: "category_group",
  serverPluralName: "category_groups",
  displayName: "Category Groups",
  allowCreate: true,
  allowEdit: true,
  allowDelete: true,
  showRowActions: true,
  showSearch: false,
  showFiltersInDrawer: true,
  customActions: actions,
  customReducers: reducers,
  customSagas: sagas,
  allowExport: true,
  titleField: "name_en",
  import: {
    enabled: true,
    extensions: ["xls", "csv", "application/vnd.openxmlformats-officedocument", "xlsx"],
    paramName: "file",
    method: "post",
    endpoint: "/admin/category_groups/import",
  },
  globalActions: [
    {
      label: { en: "Download import sheet Template", ar: "تنزيل نموذج" },
      name: "downloadImportTemplate",
    },
  ],
  fields: [
    {
      identifier: "id",
      label: "ID",
      accessor: "id",
      inList: true,
      usedToShow: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      identifier: "name_en",
      label: { en: "English name", ar: "الاسم بالانجليزية" },
      accessor: "name_en",
      inList: true,
      type: "string",
      required: true,
    },
    {
      identifier: "name_ar",
      label: { en: "Arabic name", ar: "الاسم بالعربية" },
      accessor: "name_ar",
      inList: true,
      type: "string",
      required: true,
    },
    {
      identifier: "code",
      label: { en: "Code", ar: "الكود" },
      accessor: "code",
      inList: true,
      type: "string",
      required: true,
    },
    {
      identifier: "dashboard",
      label: { en: "Dashboard", ar: "لوحة التحكم" },
      accessor: "dashboard",
      inList: true,
      disabled: (action) => action === "edit",
      type: "select",
      options: [
        { value: "eta", label: "ETA" },
        { value: "eda", label: "EDA" },
      ],
      required: true,
      dependee: true,
    },
    {
      identifier: "active",
      label: { en: "Status", ar: "الحالة" },
      accessor: "active",
      type: "select",
      inList: true,
      options: [
        { value: true, label: { en: "Active", ar: "نشط" } },
        { value: false, label: { en: "Inactive", ar: "غير نشط" } },
      ],
    },
    {
      identifier: "created_at",
      label: { en: "Created at", ar: "تاريخ الإنشاء" },
      accessor: (dataObject) => moment(dataObject.created_at).format("DD-MM-YYYY hh:mm A"),
      inList: true,
      type: "date",
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      identifier: "updated_at",
      label: { en: "Updated at", ar: "تم التحديث في" },
      accessor: (dataObject) => moment(dataObject.updated_at).format("DD-MM-YYYY hh:mm A"),
      inList: true,
      type: "date",
      hideInEdit: true,
      hideInCreate: true,
    },
    {
      identifier: "category_ids",
      label: "Categories",
      type: "reference",
      isSearchable: true,
      multiple: true,
      accessor: (dataObject) => (dataObject.categories ? dataObject.categories : []),
      dependsOn: "dashboard",
      dependsOnAny: true,
      optionsEntity: {
        name: "category",
        labelField: "name",
        valueField: "id",
        filterParams: [
          {
            name: "category_type",
            value: "brick",
            type: "both",
          },
          {
            name: "dashboard",
            value: ["state", "dashboard"],
            type: "both",
          }
        ],
      },
    },
  ],
});
